export default "__VITE_ASSET__DC2XC2LW__"